/**
 * @generated SignedSource<<8e87e6c734bcd561f3d6d690de7b30b9>>
 * @relayHash f9f307a789ceb27119c4dc27261844dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 82526d3c4d575420312492efe7cd835d4aae8b673e927283a1f282e17b414384

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { InlineCreateAdditionalFieldsEntrypointQuery } from './InlineCreateAdditionalFieldsEntrypointQuery.graphql';

const node: PreloadableConcreteRequest<InlineCreateAdditionalFieldsEntrypointQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "82526d3c4d575420312492efe7cd835d4aae8b673e927283a1f282e17b414384",
    "metadata": {},
    "name": "InlineCreateAdditionalFieldsEntrypointQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
